module.exports = __webpack_public_path__ + "media/images/service-icon-02-4d1d1281d085bc8b47dfed3fe512261a.png";